var app = angular.module("leonardo");

var DeletedPropertiesFilters = function($scope, $rootScope, FilterService) {

  $scope.name = '';

  $scope.filter = function() {
    if ($scope.name.length === 0) {
      FilterService.removeFilter('search');
    }
    else FilterService.setFilter('search', $scope.name);
    $rootScope.$broadcast('filter-property-deleted:updated');
  };

  $scope.clear = function() {
    $scope.name = '';
    FilterService.removeFilter('search');
    $rootScope.$broadcast('filters-property-reports:clear');
  };

};

app.controller('DeletedPropertiesFilters', ['$scope', '$rootScope', 'FilterService', DeletedPropertiesFilters]);
